import { render } from "./doubleTank3D.vue?vue&type=template&id=3e4b549c"
import script from "./doubleTank3D.vue?vue&type=script&lang=js"
export * from "./doubleTank3D.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/display-measurement-prd-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__